import React from 'react';

import { TAB } from '../PlaybookDetailPage';

import PromptsTab from '../PromptsTab/PromptsTab';
import ScenariosTab from '../ScenariosTab/ScenariosTab';
import PlaybookSettingsTab from '../PlaybookSettingsTab/PlaybookSettingsTab';

const PlaybookPageMainContent = ({
    activeTab,
    playbookDetail,
    setPlaybookDetail,
    playbookViewsResponse,
    isEditable,
}) => {
    const settingsTabClassName = activeTab === TAB.settings ? 'block' : 'hidden';
    const scenariosTabClassName = activeTab === TAB.scenarios ? 'block' : 'hidden';
    const promptsTabClassName = activeTab === TAB.prompts ? 'block' : 'hidden';

    return (
        <>
            <div className={settingsTabClassName}>
                <PlaybookSettingsTab
                    playbookDetail={playbookDetail}
                    setPlaybookDetail={setPlaybookDetail}
                    isEditable={isEditable}
                    playbookViewsResponse={playbookViewsResponse}
                />
            </div>

            <div className={scenariosTabClassName}>
                <ScenariosTab
                    playbookDetail={playbookDetail}
                    setPlaybookDetail={setPlaybookDetail}
                    isEditable={isEditable}
                />
            </div>

            <div className={promptsTabClassName}>
                <PromptsTab
                    playbookId={playbookDetail.id}
                    prompts={playbookDetail.prompts}
                    setPlaybookDetail={setPlaybookDetail}
                    isEditable={isEditable}
                />
            </div>
        </>
    );
};

export default PlaybookPageMainContent;
